import React from 'react';
const stats = [{
  num: '3.400+',
  label: 'Colegios usan este material como base didáctica oficial en Básica y Primaria.'
}, {
  num: '94%',
  label: 'Reduce tu carga administrativa semanal de planificación.'
}, {
  num: '+1,200',
  label: 'Reseñas verificadas de docentes en 14 países de habla hispana.'
}, {
  num: '6',
  label: 'Tomos curriculares — uno por cada grado de Primaria.'
}];
const standards = ['Diseñado bajo estándares internacionales de currículo.', 'Listo para 1.º a 6.º de Primaria / Educación Básica.', 'Contenido neutro: imprimible, digital o para proyectar en aula.'];
export function TrustBar() {
  return <section className="w-full bg-bg-alt py-12 sm:py-16 border-y border-border-light px-4 relative overflow-hidden" data-id="element-258">
      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-primary/5 to-transparent" data-id="element-259"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-260">
        {/* Stats grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 mb-10 sm:mb-12" data-id="element-261">
          {stats.map((stat, i) => <div key={i} className="text-center" data-id="element-262">
              <div className="text-primary font-black text-2xl sm:text-4xl mb-2" data-id="element-263">
                {stat.num}
              </div>
              <p className="text-text-sec text-xs sm:text-sm leading-snug" data-id="element-264">
                {stat.label}
              </p>
            </div>)}
        </div>

        {/* Professional standard */}
        <div className="border-t border-border-light pt-8 sm:pt-10" data-id="element-265">
          <p className="text-center text-primary font-bold uppercase tracking-wider text-xs sm:text-sm mb-5" data-id="element-266">
            El estándar que une a los mejores docentes 🌎
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6" data-id="element-267">
            {standards.map((s, i) => <div key={i} className="flex items-start gap-3 bg-primary/5 border border-primary/10 rounded-xl px-4 py-3" data-id="element-268">
                <span className="text-check-green text-sm mt-0.5" data-id="element-269">✓</span>
                <p className="text-text-sec text-sm leading-snug" data-id="element-270">{s}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}